import React from 'react';
import PropTypes from 'prop-types';

import {Box, Heading, useTheme} from '@spothero/ui';

import {titleAreaStyleProps, titleStyleProps} from './TitleAreaStyleProps';

const TitleArea = ({destinationName}) => {
    const {
        partnerWidgetStyles: {titleAreaStyles: customTitleAreaStyles},
    } = useTheme();

    return (
        <Box {...titleAreaStyleProps} {...customTitleAreaStyles.titleContainer}>
            <Heading
                as="h1"
                {...titleStyleProps}
                {...customTitleAreaStyles.title}
            >{`${destinationName || 'SpotHero Event'} Parking`}</Heading>
        </Box>
    );
};

TitleArea.propTypes = {
    destinationName: PropTypes.string,
};

export default TitleArea;
